// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    IconButton,
    Fab,
    Autocomplete,
    TableCell,
    DialogActions
} from '@mui/material'

import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import { useNavigate, useSearchParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import { useToast } from '../../../../components/ToastProvider';
import Swal from 'sweetalert2';

export default function Add() {
    const { showToast, hideToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token
    const [searchParams] = useSearchParams();
    const pclass: any = searchParams.get('class') || null;
    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    // ** State
    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [openBarang, setOpenBarang] = useState<boolean>(false)

    const [isDetailBarang, setIsDetailBarang] = useState<boolean>(false)
    const [listDetailBarang, setListDetailBarang] = useState<any[]>([])
    const [isWO, setIsWO] = useState<boolean>(false)

    const [rowsDataDetail, setRowsDataDetail] = useState<any[]>([])
    const [listWO, setListWO] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)


    useEffect(() => {
        getDoctag()
    }, [pclass])

    const getDoctag = () => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
            .get(url, {
                params: {
                    syscabang_id: cabang,
                    sysmenu_id: 37
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDoctag(data)
                    if (pclass != null) {
                        const doctagMap = {
                            12604000001: 12604000006,
                            12604000002: 12604000007,
                            12604000003: 12604000008,
                            12604000004: 12604000009,
                            12604000005: 12604000010
                        }

                        const targetId = doctagMap[pclass]

                        if (targetId) {
                            const defaultDoctag = data.find(item => item.id === targetId)

                            if (defaultDoctag) {
                                setValDoctag(defaultDoctag)
                                setValue('sysdoctag_id', defaultDoctag.id)
                            }

                            if (defaultDoctag.id == 12512000001 || defaultDoctag.id == 12604000006 || defaultDoctag.id == 12604000007
                                || defaultDoctag.id == 12604000008
                                || defaultDoctag.id == 12604000009
                                || defaultDoctag.id == 12604000010) {
                                setIsWO(true)
                            }
                        }
                    }
                } else {
                    showToast(response.data.message, "error");
                }
            })

    }

    const getListMasterBarangNew = () => {
        const url = apiUrl.apiUrl + '/purchasing/pr/list-barang'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDetailBarang(data)
                } else {
                    showToast(response.data.message, "error");
                }
            })
    }

    const getWO = () => {
        const url = apiUrl.apiUrl + '/mm/usage/list-wo'
        axios.get(url, {
            params: {},
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListWO(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const navigate = useNavigate();

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        keterangan: any,
        detailBarang: any
        total: any,
        id_pr: any,
        wo_order_id: any
    }

    const defaultValues = {
        syscabang_id: cabang,
        id_pr: null,
        wo_order_id: null
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })


    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
        if (newValue.id == 12512000001 || newValue.id == 12604000006 || newValue.id == 12604000007
            || newValue.id == 12604000008
            || newValue.id == 12604000009
            || newValue.id == 12604000010) {
            setIsWO(true)
        } else {
            setIsWO(false)
            setValue('wo_order_id', null)
        }
    }

    const handleClickDialog = (x: any) => {
        setOpenBarang(true)
        getListMasterBarangNew()
        setIsDetailBarang(x)
    }
    const handleCloseDialog = () => setOpenBarang(false)


    const handleTable = (index: any, evnt: any, date: any, type: any) => {
        if (date == null) {
            const { name, value } = evnt.target
            const rowsInput = [...rowsDataDetail]
            rowsInput[index][name] = value
            setRowsDataDetail(rowsInput)
        } else {
            const Pdate = date.toISOString().split('T')[0]
            const rowsInput = [...rowsDataDetail]
            rowsInput[index].Tanggal_Kebutuhan = Pdate
            setRowsDataDetail(rowsInput)
        }
        const rows = [...rowsDataDetail]
        const total = rows[index].Harga * rows[index].Quantity
        rows[index].Total = total
        setRowsDataDetail(rows)

    }

    const deleteTableRows = (index: any) => {
        const rows = [...rowsDataDetail]
        rows.splice(index, 1)
        setRowsDataDetail(rows)
    }

    const rowClickBarang = (e: any) => {
        const data = e.data
        addDetailBarangNew(data.id)
        setOpenBarang(false)
    }

    const addDetailBarangNew = (mb_id: any) => {

        const url = apiUrl.apiUrl + '/purchasing/pr/check-barang/' + mb_id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data

                    data.forEach((element: any) => {
                        const rowsInput = {
                            id: '',
                            accbudget_detail_d_id: element.accbudget_detail_d_id,
                            mmbarang_id: element.mmbarang_id,
                            mmsatuan_id: element.mmsatuan_id,
                            mmsatuan_doc_id: element.mmsatuan_doc_id,
                            Kode: element.Kode,
                            Nama_Barang: element.Nama_Barang,
                            Keterangan: element.Keterangan,
                            Tanggal_Kebutuhan: element.Tanggal_Kebutuhan?.split(" ")[0],
                            Quantity: element.Quantity,
                            konversi: element.konversi,
                            Harga: element.Harga,
                            Satuan: element.Satuan,
                            Total: element.Total,
                            Minimum_Quotation: element.Minimum_Quotation,
                            is_aktif: element.Aktif
                        }
                        setRowsDataDetail([...rowsDataDetail, rowsInput])
                    })
                } else {
                    showToast(response.data.message, "error");
                }
            })
    }

    const rowClickWO = (e: any) => {
        const data = e.data
        setValue('wo_order_id', data?.id)
        setOpenDialog(false)
    }

    const convertComponent = [
        {
            key: 'link',
            minWidth: 300,
            renderCell: ({ row }: any) => {
                const url = row.data?.link;

                if (!url) {
                    return <span style={{ color: "#999" }}>Tidak ada gambar</span>;
                }

                const openImage = () => {
                    Swal.fire({
                        title: 'Preview Gambar',
                        imageUrl: url,
                        imageWidth: 400,     // atur ukuran gambar
                        imageHeight: 'auto',
                        imageAlt: 'Preview',
                        showCloseButton: true,
                        showConfirmButton: false,
                        background: '#f9f9f9',
                        didClose: () => {
                            setOpenDialog(true);
                        }
                    });
                };

                return (
                    <img
                        src={url}
                        alt="Preview"
                        style={{
                            height: "120px",
                            width: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                            cursor: "pointer",
                        }}
                        onClick={(e: React.MouseEvent<HTMLImageElement>) => {
                            e.stopPropagation(); // cegah rowClick
                            setOpenDialog(false);
                            openImage()
                        }}
                    />
                );
            }
        }
    ];

    setValue('detailBarang', JSON.stringify(rowsDataDetail))
    const sumBarang = rowsDataDetail.reduce(sum, 0)

    function sum(accumulator: any, a: any) {
        return accumulator + a.Total
    }

    setValue('total', sumBarang)

    const onSubmit = (data: any) => {
        showToast("Loading", "loading");
        const url = apiUrl.apiUrl + '/purchasing/pr/save-pr'
        axios
            .post(url, data, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, "success");
                    const id = response.data.data
                    navigate('/purchasing/purchase-request/detail/' + id)
                } else {
                    showToast(response.data.message, "error");
                }
            })
            .catch(error => {
                showToast(error.message, "error");
            })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Purchase Request
                    </Typography>
                    <Divider sx={{ m: 3 }} />

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sysdoctag_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valDoctag}
                                                options={listDoctag}
                                                id='sysdoctag_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={pclass != null ? () => { } : handleChangeAutocompleteDoctag}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                readOnly={pclass != null}
                                                disableClearable={pclass != null}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Document Tag'
                                                        error={Boolean(errors.sysdoctag_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sysdoctag_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            {isWO ? (
                                <>
                                    <Grid item xs={12} md={11} sm={11}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='wo_order_id'
                                                control={control}
                                                render={({ field: { value } }) => (
                                                    <TextField
                                                        label='ID WO'
                                                        type='text'
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={1} sm={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Fab color='info' size='medium' onClick={() => {
                                            getWO();
                                            setOpenDialog(true);
                                        }}
                                        >
                                            <Icon icon='mdi:search' fontSize={35} color='white' />
                                        </Fab>
                                    </Grid>
                                </>
                            ) : ('')}
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan PR'
                                                error={Boolean(errors.keterangan)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                                multiline
                                                rows={3}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            {/* <Grid item xs={12} sm={12}>
                                <Box sx={{ backgroundColor: '#ffeaa7', p: 1 }}>
                                    <Typography variant='body1' sx={{ color: '#212121', textAlign: 'center', fontWeight: 600 }}>
                                        DETAIL BARANG
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        mb: 1,
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    <Fab
                                        variant='extended'
                                        color='primary'
                                        sx={{ '& svg': { mr: 1 } }}
                                        onClick={() => handleClickDialog(true)}
                                    >
                                        <Icon icon='mdi:search' />
                                        Cari Barang
                                    </Fab>
                                    <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.open('/mm/master-barang/add', '_blank')}>
                                        <Icon icon='mdi:plus' />
                                        Tambah Master Barang
                                    </Fab>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell></TableCell>
                                                <TableCell sx={{ textAlign: 'left' }}>Tanggal Kebutuhan</TableCell>
                                                <TableCell>ID Barang</TableCell>
                                                <TableCell>Nama Barang</TableCell>
                                                <TableCell>Satuan</TableCell>
                                                <TableCell>Quantity</TableCell>
                                                <TableCell >Keterangan</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rowsDataDetail.map((item: any, index: any) => (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        backgroundColor: item.is_aktif == true ? '' : '#F3C1C1'
                                                    }}
                                                >
                                                    <TableCell>
                                                        <IconButton color='error' onClick={() => deleteTableRows(index)}>
                                                            <Icon icon='mdi:trash' fontSize={20} />
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            label='Tanggal'
                                                            type='date'
                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                handleTable(index, event, event.target.value, "barang")
                                                            }}
                                                            value={item.Tanggal_Kebutuhan}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>{item.mmbarang_id}</TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            rows={3}
                                                            multiline
                                                            label='Nama Barang'
                                                            name='Nama_Barang'
                                                            onChange={evnt => {
                                                                handleTable(index, evnt, null, 'barang')
                                                            }}
                                                            value={item.Nama_Barang}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>{item.Satuan}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        <TextField
                                                            label='Quantity'
                                                            name='Quantity'
                                                            type='number'
                                                            onChange={evnt => {
                                                                handleTable(index, evnt, null, 'barang')
                                                            }}
                                                            value={item.Quantity}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        <TextField
                                                            fullWidth
                                                            rows={2}
                                                            multiline
                                                            label='Keterangan'
                                                            name='Keterangan'
                                                            onChange={evnt => {
                                                                handleTable(index, evnt, null, 'barang')
                                                            }}
                                                            value={item.Keterangan}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid> */}
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>

            <Dialog
                onClose={handleCloseDialog}
                aria-labelledby='customized-dialog-title'
                open={openBarang}
                fullWidth={true}
                maxWidth='xl'
            >
                <DialogTitle id='customized-dialog-title'>
                    {isDetailBarang ? (
                        <Typography variant='h6' component='span' sx={{ color: '#212121' }}>
                            Pilih Barang
                        </Typography>
                    ) : (
                        <Typography variant='h6' component='span' sx={{ color: '#212121' }}>
                            Pilih Akun
                        </Typography>
                    )}
                    <IconButton
                        aria-label='close'
                        onClick={handleCloseDialog}
                        sx={{ top: 10, right: 10, position: 'absolute', color: 'grey.500' }}
                    >
                        <Icon icon='mdi:close' />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 4 }}>
                    <MsiDatagrid array={listDetailBarang} rowClick={rowClickBarang} />
                </DialogContent>
            </Dialog>

            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        List WO
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 4 }}>
                    <Grid container spacing={4}>
                        <MsiDatagrid array={listWO} rowClick={rowClickWO} hiddenColumns={['id']} customRender={convertComponent} />
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
